import { useEffect, useState } from 'react'
import { message, Button } from 'antd'
import styles from './style.module.scss'
import { history } from '../../redux/store'
import { userRouter } from '../../route'
import { GET_USER_INFO } from '../../api/CommonApi'
import { isResponseCodeSuccess } from '../../tools/util'
// 账号信息
const Baseaccount = () => {
  const supRoute = userRouter[1].url
  const [useInfo, setuseInfo] = useState<any>({})
  useEffect(() => {
    getData()
    // eslint-disable-next-line
  }, [])
  // 获取用户信息
  async function getData() {
    const res: any = await GET_USER_INFO()
    if (isResponseCodeSuccess(res.code)) {
      const data = res.data
      setuseInfo(data)
    } else {
      message.info(res.msg)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.usesinfo}>
        <div className={styles.title}>基本信息</div>
        <div className={styles.useslist}>
          <p>
            <span>姓名&nbsp;:</span>
            <span>{useInfo.name}</span>
          </p>
          <p>
            <span>手机号&nbsp;:</span>
            <span>{useInfo.phone}</span>
          </p>
          <p>
            <span>邮箱&nbsp;:</span>
            <span>{useInfo.email}</span>
          </p>
          <p>
            <span>员工编号&nbsp;:</span>
            <span>{useInfo.code}</span>
          </p>
          <p>
            <span>岗位&nbsp;:</span>
            <span>{useInfo.job}</span>
          </p>
          <p>
            <span>所属组织&nbsp;:</span>
            <span>{useInfo.orgname}</span>
          </p>
          <p>
            <span>所属部门&nbsp;:</span>
            <span>{useInfo.deptname}</span>
          </p>
          <p>
            <span>用户角色&nbsp;:</span>
            <span>{useInfo.rolenames}</span>
          </p>
        </div>
      </div>
      <div className={styles.password}>
        <div className={styles.title}>密码设置</div>
        <div className={styles.useslist}>
          <p>
            <span>密码&nbsp;:</span>
            <span>******</span>
            <Button
              type="primary"
              style={{ marginLeft: 70 }}
              onClick={() =>
                history.replace({ pathname: `${supRoute}/password` })
              }
            >
              重置密码
            </Button>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Baseaccount
import { useEffect, useState } from 'react'
import { message, Button } from 'antd'
import styles from './style.module.scss'
import { history } from '../../redux/store'
import { userRouter } from '../../route'
import { GET_USER_INFO } from '../../api/CommonApi'
import { isResponseCodeSuccess } from '../../tools/util'
// 账号信息
const Baseaccount = () => {
  const supRoute = userRouter[1].url
  const [useInfo, setuseInfo] = useState<any>({})
  useEffect(() => {
    getData()
    // eslint-disable-next-line
  }, [])
  // 获取用户信息
  async function getData() {
    const res: any = await GET_USER_INFO()
    if (isResponseCodeSuccess(res.code)) {
      const data = res.data
      setuseInfo(data)
    } else {
      message.info(res.msg)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.usesinfo}>
        <div className={styles.title}>基本信息</div>
        <div className={styles.useslist}>
          <p>
            <span>姓名&nbsp;:</span>
            <span>{useInfo.name}</span>
          </p>
          <p>
            <span>手机号&nbsp;:</span>
            <span>{useInfo.phone}</span>
          </p>
          <p>
            <span>邮箱&nbsp;:</span>
            <span>{useInfo.email}</span>
          </p>
          <p>
            <span>员工编号&nbsp;:</span>
            <span>{useInfo.code}</span>
          </p>
          <p>
            <span>岗位&nbsp;:</span>
            <span>{useInfo.job}</span>
          </p>
          <p>
            <span>所属组织&nbsp;:</span>
            <span>{useInfo.orgname}</span>
          </p>
          <p>
            <span>所属部门&nbsp;:</span>
            <span>{useInfo.deptname}</span>
          </p>
          <p>
            <span>用户角色&nbsp;:</span>
            <span>{useInfo.rolenames}</span>
          </p>
        </div>
      </div>
      <div className={styles.password}>
        <div className={styles.title}>密码设置</div>
        <div className={styles.useslist}>
          <p>
            <span>密码&nbsp;:</span>
            <span>******</span>
            <Button
              type="primary"
              style={{ marginLeft: 70 }}
              onClick={() =>
                history.replace({ pathname: `${supRoute}/password` })
              }
            >
              重置密码
            </Button>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Baseaccount
